// removed by extract-text-webpack-plugin
module.exports = {"component":"_3_nIoNYI4MeaGIYeI7DUuP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Mobile/SingleStep/singleStep.css
// module id = 1243
// module chunks = 2